(function () {
  // --- h2ベースの挿入（2見出しごと） ---
  const INTERVAL = 2;     // 何個ごとに挿入するか
  const START_INDEX = 0;  // 最初のh2(0番目)から対象
  const MAX_ADS = 15;     // 暴走防止の安全上限（通常はINTERVALで決まる）

  // --- h3ランダム挿入（長文記事のみ追加） ---
  const H2_MIN = 6;       // h2がこの数以上、または
  const H3_MIN = 10;      // h3がこの数以上で発動
  const H3_RATIO = 0.15;   // 候補h3数に対する挿入割合
  const H3_MAX = 8;       // h3挿入数の上限

  const content = document.querySelector('.article-template__content');
  if (!content) return;

  // ビューポート手前に来た広告だけ読み込む（lazy load）
  const LAZY_LOAD = true;           // ← true で lazy load 有効 / false で即読み込み
  const ROOT_MARGIN = '600px 0px';  // 表示の手前で先読みしてビューアビリティを確保
  function loadAd() {
    (adsbygoogle = window.adsbygoogle || []).push({}); // ins 1個につき push 1回
  }
  const io = LAZY_LOAD && 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          loadAd();
          obs.unobserve(e.target); // 1枠1pushを保証
        });
      }, { rootMargin: ROOT_MARGIN })
    : null;

  function insertAdBefore(el) {
    const ins = document.createElement('ins');
    ins.className = 'adsbygoogle';
    ins.style.cssText = 'display:block; text-align:center;';
    ins.setAttribute('data-ad-layout', 'in-article');
    ins.setAttribute('data-ad-format', 'fluid');
    ins.setAttribute('data-ad-client', 'ca-pub-8070459482460907');
    ins.setAttribute('data-ad-slot', '9182631696');
    el.parentNode.insertBefore(ins, el);
    if (io) {
      io.observe(ins); // 画面手前に来たら読み込む
    } else {
      loadAd(); // 非対応ブラウザは従来どおり即読み込み
    }
  }

  const h2s = Array.prototype.slice.call(content.querySelectorAll('h2'));
  const h3s = Array.prototype.slice.call(content.querySelectorAll('h3'));

  // 1) h2ベース：2見出しごと
  let inserted = 0;
  h2s.forEach(function (h2, i) {
    if (i < START_INDEX) return;
    if ((i - START_INDEX) % INTERVAL !== 0) return;
    if (inserted >= MAX_ADS) return;
    insertAdBefore(h2);
    inserted++;
  });

  // 2) h3ランダム：条件を満たす長文記事のみ
  if (h2s.length >= H2_MIN || h3s.length >= H3_MIN) {
    // 直前の見出しがh2なら「セクション先頭h3」→除外
    function isSectionFirstH3(h3) {
      let el = h3.previousElementSibling;
      while (el) {
        if (el.tagName === 'H2') return true;
        if (el.tagName === 'H3') return false;
        el = el.previousElementSibling;
      }
      return true;
    }

    // 次の見出しがh2なら「セクション末尾h3」→除外（h2広告との近接を防ぐ）
    function isSectionLastH3(h3) {
      let el = h3.nextElementSibling;
      while (el) {
        if (el.tagName === 'H2') return true;
        if (el.tagName === 'H3') return false;
        el = el.nextElementSibling;
      }
      return true;
    }

    // 候補：セクションの先頭h3・末尾h3を除外し、中間h3のみ対象
    const candidates = h3s.filter(function (h3) {
      return !isSectionFirstH3(h3) && !isSectionLastH3(h3);
    });

    // 挿入数：候補数の割合（最低1・上限H3_MAX）
    const need = Math.min(H3_MAX, Math.max(1, Math.ceil(candidates.length * H3_RATIO)));

    // シャッフル（Fisher-Yates）して先頭からneed個
    for (let i = candidates.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const t = candidates[i];
      candidates[i] = candidates[j];
      candidates[j] = t;
    }
    candidates.slice(0, need).forEach(insertAdBefore);
  }
})();
